// Google only accepts a fixed set of employmentType values in JobPosting structured data:
// https://developers.google.com/search/docs/appearance/structured-data/job-posting
// The CMS "Contract Type" wording ("Permanent", "Contract", ...) is not valid on its own, so
// map it before it reaches the schema. Values with no employment-type equivalent (e.g. "Remote",
// which describes the location rather than the contract) are dropped.
const GOOGLE_EMPLOYMENT_TYPES = {
  permanent: "FULL_TIME",
  "full time": "FULL_TIME",
  "full-time": "FULL_TIME",
  "part time": "PART_TIME",
  "part-time": "PART_TIME",
  contract: "CONTRACTOR",
  contractor: "CONTRACTOR",
  "fixed term": "CONTRACTOR",
  freelance: "CONTRACTOR",
  interim: "CONTRACTOR",
  temporary: "TEMPORARY",
  temp: "TEMPORARY",
  internship: "INTERN",
  intern: "INTERN",
  volunteer: "VOLUNTEER",
};

export function getEmploymentType(categories) {
  if (!categories) return null;

  const mapped = categories
    .filter((category) => category.name == "Contract Type")
    .flatMap((category) => category.values || [])
    .map((value) => GOOGLE_EMPLOYMENT_TYPES[String(value.name || "").trim().toLowerCase()])
    .filter(Boolean);

  const unique = [...new Set(mapped)];

  if (unique.length == 0) return null;
  return unique.length == 1 ? unique[0] : unique;
}
